import { render, staticRenderFns } from "./SalaryExport.vue?vue&type=template&id=87157266"
import script from "./SalaryExport.vue?vue&type=script&lang=js"
export * from "./SalaryExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports